// extracted by mini-css-extract-plugin
export default {"button":"RatingSubmitButton_button__jP-t3"};